import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, notification, Row } from 'antd';
import { useGlobalState } from './GlobalState';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import SelectSwim from './SelectSwim';
import moment from 'moment-timezone';
import axios from 'axios';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import eye from '../assets/images/Eye.png';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Cell, Row as RowT, StickyTable } from 'react-sticky-table';
import { exotic_fishery } from '../../common/Utils';
import { addToDateString } from '../../admin/components/bookings/components/SelectSwim';
import SwimKeyModal from './SwimKeyModal';

export default function Step2({ fishery_id }) {
  const is_exotic_fishery = fishery_id === exotic_fishery;
  const [loading, setLoading] = useState(true);
  const [userSelectedSwims] = useGlobalState('userSelectedSwims');
  const [userSelectedDoubleSwim] = useGlobalState('userSelectedDoubleSwim');

  const [enableSwimSelect] = useState(true);
  const [swimImages, setSwimImages] = useState(null);

  const [swimAvailableData, setSwimAvailableData] =
    useGlobalState('swimAvailableData');
  const [, setunSelectableSwimIds] = useGlobalState('unSelectableSwimIds');

  const [userSelectedLakeId] = useGlobalState('userSelectedLakeId');
  const [userSelectedLakeName] = useGlobalState('userSelectedLakeName');
  const [, setEstimatedPricing] = useGlobalState('estimatedPricing');

  const [userSelectedAnglers] = useGlobalState('userSelectedAnglers');
  const [userSelectedRods] = useGlobalState('userSelectedRods');
  const [arrivalTime] = useGlobalState('arrivalTime');
  const [departureTime] = useGlobalState('departureTime');
  const [lakeExclusive] = useGlobalState('lakeExclusive');
  const [bookingType] = useGlobalState('bookingType');
  const [userSelectedPakage] = useGlobalState('userSelectedPakage');
  const [lakeDetails] = useGlobalState('lakeDetails');

  const [showKeyModal, setShowKeyModal] = useState(false);
  const is_exotic_arapaima_lake =
    userSelectedLakeId === 'a4688274-3f67-40a5-be8d-a8dc51c053b3';
  const axios_config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  const generateSlideImages = (images) => {
    let dList = [];
    let swim_names = [];

    swimAvailableData.swims.forEach((swim) => {
      let _d = swimAvailableData.double_swims
        ? swimAvailableData.double_swims.indexOf(swim.id) > -1
          ? ' (Double)'
          : ''
        : '';
      swim_names.push(swim.name + _d);
    });

    dList.push({
      original: images[0],
      thumbnail: images[0],
      description: is_exotic_fishery ? '' : 'Lake View',
    });

    images.slice(1, images.length).forEach((image, index) => {
      dList.push({
        original: image,
        thumbnail: image,
        description: is_exotic_fishery ? '' : swim_names[index],
      });
    });

    return dList;
  };

  const getSwimClickableEntries = (data) => {
    setunSelectableSwimIds([]);
    let _dates = [];
    let selectedDates = data.selected_dates;
    data.swims.forEach((swim) => {
      data.display_dates.forEach((date) => {
        if (
          data.booked_dates &&
          data.booked_dates[swim.id] &&
          data.booked_dates[swim.id].indexOf(date) > -1
        ) {
          if (selectedDates.indexOf(date) !== -1) {
            _dates.push(swim.id);
          }
        }
      });
    });

    const uniqueDates = [...new Set(_dates)];

    setunSelectableSwimIds(uniqueDates);
    // This will render next day
  };
  const getSwimAvailability = () => {
    let payload_data = {
      arrival_timestamp: arrivalTime,
      departure_timestamp: departureTime,
      lake_id: userSelectedLakeId,
      anglers: userSelectedAnglers,
      guest: userSelectedRods,
      swims:
        userSelectedDoubleSwim || userSelectedSwims
          ? userSelectedSwims.concat(userSelectedDoubleSwim)
          : [],
      is_mobile_device: window.innerWidth <= 700,
      book_lake_exclusive: lakeExclusive,
      booking_type: bookingType,
      ...(userSelectedPakage && {
        custom_slot_id:
          lakeDetails?.custom_slot_days[userSelectedPakage - 1]?.id,
      }),
    };

    axios
      .post('booking/swim_ticket/availability', payload_data, axios_config)
      .then((res) => {
        if (res.status === 200) {
          let res_data = res.data.result;
          setSwimAvailableData(res_data);
          setSwimImages(res_data.images);
          getSwimClickableEntries(res_data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 500) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description: 'Server Response failed. Please try again later',
            });
          } else if (err.response.status === 401) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                'Your action will not be saved. Please Login and try again!',
            });
          } else if (err.response.status === 400) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description: err.response.data['detail'],
            });
          } else if (err.response.status === 422) {
            if (err.response.data['detail'] === 'Signature has expired') {
              notification.error({
                message: <div className='gSemiBold'>There was an issue!</div>,
                style: { border: '1px #D34545 solid' },
                placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
                className: 'gRegular br10',
                description:
                  'Login session has been expired. Please Login to continue!',
              });
            } else {
              notification.error({
                message: <div className='gSemiBold'>There was an issue!</div>,
                style: { border: '1px #D34545 solid' },
                placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
                className: 'gRegular br10',
                description:
                  "OOPS! Server didn't like the request. If this persists please contact support team",
              });
            }
          } else if (err.response.status === 423) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description:
                'Sorry ! this booking slot has been booked by another user, Try different booking!',
            });
          }
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing result',
          });
        }
      })
      .finally(() => {});
  };

  const reformatTableDate = (_date) => {
    return moment(new Date(_date)).format('Do MMM').toString();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getSwimAvailability();
  }, []);

  const selectedDates = swimAvailableData?.selected_dates || [];
  const isSelectedDate = (date) => selectedDates.indexOf(date) !== -1;
  const isAdjacentDate = (date) =>
    selectedDates.indexOf(addToDateString(date, -1)) !== -1 ||
    selectedDates.indexOf(addToDateString(date, 1)) !== -1;

  return (
    <div>
      <h1 className='fs-25  gSemiBold'>
        {` Perfect! Time to select your ${
          is_exotic_fishery && !is_exotic_arapaima_lake ? 'room(s)' : 'swim(s)'
        }!`}
      </h1>
      <Col span={24} className='booking-session-heading h-40'>
        <img
          src={eye}
          alt={'Open eye icon'}
          style={{
            width: '16px',
            verticalAlign: 'sub',
          }}
        />
        <span className='white   fs-16 pd-left-10 pd-2'>
          {is_exotic_fishery ? 'Gallery' : 'Swim gallery'}
        </span>
      </Col>
      {!loading ? (
        <>
          <Col
            span={24}
            id='bookings-swim-images-web-gallery'
            className={'mg-bottom-30'}
          >
            <ImageGallery
              items={generateSlideImages(swimImages)}
              thumbnailPosition='left'
              showFullscreenButton={false}
              showPlayButton={false}
              showBullets={false}
              showNav={false}
            />
          </Col>
          <Col
            span={24}
            id='bookings-swim-images-mobile-gallery'
            className={'mg-bottom-30'}
          >
            <ResponsiveCarousel
              showThumbs={false}
              showArrows={true}
              showIndicators={false}
              infiniteLoop={true}
              dynamicHeight={true}
              autoPlay={false}
            >
              {generateSlideImages(swimImages).map((x) => {
                return (
                  <div>
                    <img alt={x.description} src={x.thumbnail} />
                    {fishery_id !== exotic_fishery && (
                      <p className='legend'>{x.description}</p>
                    )}
                  </div>
                );
              })}
            </ResponsiveCarousel>
          </Col>
          <Col span={24} className='booking-session-heading h-40'>
            <span className='white fs-16 pd-2'>
              {is_exotic_arapaima_lake
                ? 'Select from the available swims. All anglers should be added to one swim based on how the arapaima lake works.'
                : is_exotic_fishery
                  ? 'Select from the available suites (max 2 guests per suite). King Suites contain one king size bed, Twin Suites contain two single beds.'
                  : 'Select your swim(s)'}{' '}
            </span>
          </Col>
          <SwimKeyModal
            visible={showKeyModal}
            onClose={() => setShowKeyModal(false)}
          />
          <Button
            type={'text'}
            className={
              'pd-left-0 pd-right-0 w-fit h-fit text-wrap txt-left mg-top-15 mg-bottom-20'
            }
          >
            <span
              className={'txt-underline blue-2 gSemiBold fs-15 cp'}
              onClick={() => setShowKeyModal(true)}
            >
              Click here to show the booking key
            </span>
          </Button>
          <Row>
            <Col span={24}>
              <div className='user-swim-select-table'>
                <StickyTable stickyHeaderCount={1} leftStickyColumnCount={1}>
                  <RowT key={1234334} className={'dates-titles-row'}>
                    <Cell key={45332} className={'swim-titles-column'} />
                    {swimAvailableData
                      ? swimAvailableData.display_dates.map((date, index) => {
                          return (
                            <Cell
                              key={index + '_' + date}
                              className={
                                isSelectedDate(date) || isAdjacentDate(date)
                                  ? 'swim-user-adjacent-range'
                                  : ''
                              }
                            >
                              {reformatTableDate(date)}
                            </Cell>
                          );
                        })
                      : ''}
                  </RowT>
                  {/*  */}
                  {swimAvailableData
                    ? swimAvailableData.swims.map((swim, index) => {
                        return (
                          <RowT key={index}>
                            <Cell className={'swim-titles-column'}>
                              {' '}
                              <p className='mg-bottom-0 txt-left'>
                                <span className='gBold '>{swim.name}</span>{' '}
                                {swim?.swim_type?.toLowerCase() !== 'standard'
                                  ? swim?.swim_type
                                  : swim?.swim_size}
                              </p>
                              <p className='mg-bottom-0 txt-left'>
                                {' '}
                                {swim?.swim_type?.toLowerCase() !== 'standard'
                                  ? swim.swim_size
                                  : ''}
                              </p>
                            </Cell>
                            {swimAvailableData.display_dates.map((date, i) => {
                              return (
                                <SelectSwim
                                  enable_swim_select={enableSwimSelect}
                                  key={i}
                                  swim_id={swim.id}
                                  date={date}
                                  index={i}
                                />
                              );
                            })}
                          </RowT>
                        );
                      })
                    : ''}
                  {/*  */}
                </StickyTable>
              </div>
              <Divider />
            </Col>
          </Row>
        </>
      ) : (
        ''
      )}
    </div>
  );
}
